$(function () {
  const asideNavigationToggle = $('.jsAsideToggle')
  const asideNavigationPopup = $('.AsideNavigation-popup')

  asideNavigationToggle.on('click', function () {
    asideNavigationPopup.toggleClass('open');
  })
})
